import { Component, OnInit } from '@angular/core';
import { HeaderComponent } from '../header/header.component';

@Component({
  selector: 'app-unavailable-feed',
  standalone: true,
  imports: [HeaderComponent],
  templateUrl: './unavailable-feed.component.html',
  styleUrl: './unavailable-feed.component.scss'
})
export class UnavailableFeedComponent implements OnInit {
  
  constructor() {
  }

  ngOnInit() {
    
  }
}
